import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { LabSidebar } from "../Layouts/LabSidebar";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";

export class MalariaPregnancyUrinalysisStoolSediment extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      malaria: "",
      uriappearance: "",
      uriph: "",
      uriprotein: "",
      uriglucose: "",
      uribilirubin: "",
      sedwbc: "",
      sedrbc: "",
      sede2cells: "",
      sedcasts: "",
      sedothers: "",
      pregnancy: "",
      stoolappearance: "",
      stoolconsistency: "",
      stoolmicroscopy: "",
      diagnosticstudies: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.modal = true;
  }

  componentDidMount() {
    var rowNumber = this.state["rowNumber"];
    var tableRow =
      '<tr><td><input className="form-control" name="Year" onChange={this.handleChange} value={Year}  type="text" required/> </td><td><textarea className="form-control" name="EvolutionPreviousPregnancy" onChange={this.handleChange} value={EvolutionPreviousPregnancy}></textarea></td><td><textarea className="form-control" name="InfantWeight" onChange={this.handleChange} value={InfantWeight}></textarea></td><td><textarea className="form-control" name="Sex" onChange={this.handleChange} value={Sex}></textarea></td> <td><textarea className="form-control" name="ModeDeliveryMode" onChange={this.handleChange} value={ModeDeliveryMode}></textarea></td><td><textarea className="form-control" name="InfantWeight" onChange={this.handleChange} value={InfantWeight}></textarea></td></tr>';
    $(".add-row").on("click", function () {
      $(".tableBody").append(tableRow);
    });
    this.setState({ rowNumber: parseInt(rowNumber) + 1 });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();
    console.log(localStorage.getItem("objectLength"));
    var objectLength = localStorage.getItem("objectLength");

    this.setState({
      Year: this.state.tablevaluesglobal[0]["Year"],
    });

    console.log(this.state);

    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      // console.log(this.state.tablevaluesglobal[i]['Year'])

      var year = this.state.tablevaluesglobal[i]["Year"];
      var dict = {
        malaria: this.state.tablevaluesglobal[i]["malaria"],
        uriappearance: this.state.tablevaluesglobal[i]["uriappearance"],
        uriph: this.state.tablevaluesglobal[i]["uriph"],
        uriprotein: this.state.tablevaluesglobal[i]["uriprotein"],
        uriglucose: this.state.tablevaluesglobal[i]["uriglucose"],
        uribilirubin: this.state.tablevaluesglobal[i]["uribilirubin"],
        sedwbc: this.state.tablevaluesglobal[i]["sedwbc"],
        sedrbc: this.state.tablevaluesglobal[i]["sedrbc"],
        sede2cells: this.state.tablevaluesglobal[i]["sede2cells"],
        sedcasts: this.state.tablevaluesglobal[i]["sedcasts"],
        sedothers: this.state.tablevaluesglobal[i]["sedothers"],
        pregnancy: this.state.tablevaluesglobal[i]["pregnancy"],
        stoolappearance: this.state.tablevaluesglobal[i]["stoolappearance"],
        stoolconsistency: this.state.tablevaluesglobal[i]["stoolconsistency"],
        stoolmicroscopy: this.state.tablevaluesglobal[i]["stoolmicroscopy"],
        diagnosticstudies: this.state.tablevaluesglobal[i]["diagnosticstudies"],
      };
      console.log(dict);
      axios
        .post(
          this.api_url+"laboratory/tests/MalariaPregnacyUrinalysisStoolSediment",
          dict,
          { headers: headers }
        )
        .then((response) => {
          console.log(response);
          // /triage/antenatal/history

          if (response.data["status"]) {
            $(".alert-success").show();
            setTimeout(function () {}, 500);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.malaria = data[i][0];
      trimobj.uriappearance = data[i][1];
      trimobj.uriph = data[i][2];
      trimobj.uriprotein = data[i][3];
      trimobj.uriglucose = data[i][4];
      trimobj.uribilirubin = data[i][5];
      trimobj.sedwbc = data[i][6];
      trimobj.sedrbc = data[i][7];
      trimobj.sede2cells = data[i][8];
      trimobj.sedcasts = data[i][9];
      trimobj.sedothers = data[i][10];
      trimobj.pregnancy = data[i][11];
      trimobj.stoolappearance = data[i][12];
      trimobj.stoolconsistency = data[i][13];
      trimobj.stoolmicroscopy = data[i][14];
      trimobj.diagnosticstudies = data[i][15];

      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  getTableValues(event) {
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [
      ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
    ];

    const columns = [
      "malaria",
      "uriappearance",
      "uriph",
      "uriprotein",
      "uriglucose",
      "uribilirubin",
      "sedwbc",
      "sedrbc",
      "sede2cells",
      "sedcasts",
      "sedothers",
      "pregnancy",
      "stoolappearance",
      "stoolconsistency",
      "stoolmicroscopy",
      "diagnosticstudies",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    return (
      <div>
        <Headers />
        <LabSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-4 text-lg-center font-weight-bold p-1">
                <p className="text-capitalize" style={font16}></p>
              </div>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  MalariaPregnancyUrinalysisStoolSediment
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default MalariaPregnancyUrinalysisStoolSediment;
